// if (!window.IntersectionObserver) {
import "custom-event-polyfill";
import "intersection-observer";
import isSSR from "venuescanner-js/services/isSSR";
// }
const onScreenEvent = !isSSR() && new CustomEvent("on-screen");
const observer =
  !isSSR() &&
  new IntersectionObserver(
    function (entries) {
      // isIntersecting is true when element and viewport are overlapping
      // isIntersecting is false when element and viewport don't overlap
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.dispatchEvent(onScreenEvent);
        }
      });
    },
    { threshold: [0] }
  );

export const ObserverIntersection = (
  el,
  { method, onlyOnce = true } = { onlyOnce: true }
) => {
  if (!isSSR()) {
    observer.observe(el);
    if (onlyOnce) {
      const stopListen = () => {
        observer.unobserve(el);
        el.removeEventListener("on-screen", stopListen);
        if (method) method();
      };
      el.addEventListener("on-screen", stopListen);
    }
  }
};
